// components/ui/FormHeader.tsx
import React from "react";
import { Baby } from "lucide-react";

interface FormHeaderProps {
  title: string;
  subtitle: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  subtitle,
  icon: Icon = Baby,
}) => {
  return (
    <>
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-400 via-cyan-400 to-indigo-400 rounded-t-3xl"></div>
      
      <div className="flex items-center mb-8">
        <div className="bg-gradient-to-br from-blue-100 to-cyan-100 p-4 rounded-2xl mr-4">
          <Icon className="text-blue-600" size={32} />
        </div>
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
            {title}
          </h2>
          <p className="text-gray-600 font-medium">{subtitle}</p>
        </div>
      </div>
    </>
  );
};